export default {
  filterBtn: `Filter`,
  editBtn: `Edit Filters`,
  pageCount: totalData => `${totalData} products`,
  sortBy: `Sort by`,
  unlocalisedBtn: `Add postcode`,
  unlocalisedText: ` to see what’s available`,
  localisedText: `Collection and delivery for `
}
